export default __webpack_public_path__ + "static/media/gambarnya.215af756.PNG";